<template>
  <div class="venue-Detail">
    <h3 class="manager-title">{{ detailInfo.MeetingTitle }}</h3>
    <van-cell-group>
      <van-cell title="审批状态">
        <template>
          <span v-if="detailInfo.ReservationState === 1" style="color:#5cadff;">（待审批）</span>
          <span v-else-if="detailInfo.ReservationState === 3" style="color:#19be6b;">（同意）</span>
          <span v-else-if="detailInfo.ReservationState === 4" style="color:#f05a4a;"
            >（不同意）</span
          >
          <span v-else-if="detailInfo.ReservationState === 2" style="color:#f90;">（已撤销）</span>
        </template>
      </van-cell>
      <van-cell title="参会人数" :value="detailInfo.UseNum" />
      <van-cell title="会议日期" :value="detailInfo.StartTime.slice(0, 11)" />
      <van-cell
        title="会议时间"
        :value="detailInfo.StartTime.slice(11, 16) + '至' + detailInfo.EndTime.slice(11, 16)"
      />
      <van-cell title="会议时长" :value="detailInfo.UseTime" />
      <van-cell
        title="会议地点"
        :value="
          detailInfo.SchoolDistrictName +
            detailInfo.BuildingName +
            detailInfo.Floor +
            detailInfo.HouseName
        "
      />
      <van-cell title="发起时间" :value="detailInfo.CreateByDate.slice(0, 16)" />
      <van-cell title="主持人" :value="detailInfo.FullName" />
      <van-cell title="会议描述" :value="detailInfo.ReservIntroduction" />
    </van-cell-group>
    <p class="line-info" style="margin-top: 20px;">参会人</p>
    <p class="line-info">{{ detailInfo.UserNames.join(" ") }}</p>

    <TwoBotttomBtn
      v-if="detailInfo.ReservationState === 1"
      left-text="不同意"
      right-text="同意"
      @cancelClick="saveAppoint(4)"
      @confirmClick="saveAppoint(3)"
    ></TwoBotttomBtn>
  </div>
</template>
<script>
import TwoBotttomBtn from "../../components/TwoBottomBtn";
export default {
  name: "MeetingMangerDetail",
  components: {
    TwoBotttomBtn
  },
  data() {
    return {
      detailInfo: {
        BuildingName: "",
        CreateByDate: "",
        EndTime: "",
        FullName: "",
        HouseFullName: "",
        HouseID: "",
        HouseName: "",
        Housenumber: "",
        IsStarted: "",
        MeetingID: "",
        MeetingTitle: "",
        ReservIntroduction: "",
        ReservationState: "",
        StartTime: "",
        UseNum: "",
        UseTime: "",
        UserNames: [],
        Volume: "",
        Week: ""
      }
    };
  },
  created() {
    this.getInfo(this.$route.params.id);
  },
  methods: {
    async saveAppoint(state) {
      let params = {
        reservationID: this.$route.params.id,
        state
      };
      let res = await this.xyapi.get(
        this.$store.state.apiPath + "/api/MeetingReservationAdmin/SetState",
        params
      );
      if (res.success) {
        this.xy.msgSuc("审批完成");
        this.$router.back();
      }
    },
    goBack() {
      this.$router.back();
    },
    revokeConfirm() {
      this.xy.confirm("撤销提示？", "您确定要撤销吗？", this.revoke);
    },

    async getInfo(id) {
      let params = {
        id
      };
      let res = await this.xyapi.get(
        this.$store.state.apiPath + "/api/MeetingReservationAdmin/Get",
        params
      );
      if (res.success) {
        res.data ? (this.detailInfo = res.data) : "";
      }
    }
  }
};
</script>
<style lang="less" scoped>
.venue-Detail {
  padding-bottom: 50px;
  .line-info {
    padding: 20px;
    font-size: 28px;
    background: #fff;
  }
  .manager-title {
    text-align: center;
    font-size: 28px;
    font-weight: 700;
    background-color: rgba(65, 150, 255, 0.1);
    line-height: 88px;
  }
}
</style>
